import React from "react";
import { connect } from "react-redux";

import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import { Icons } from "Assets/icons";
import Axios from "Source/axiosPool";
import { showToast } from "Source/globalFunction";
import _ from 'lodash'
@connect(store => {
    return {
        loggedUser: store.loggedUser,
        notes: store.notes,
        conversations: store.conversations,
        conversation: store.conversation

     };
})
class Read extends React.Component {
    constructor(props) {
        super(props);
    }
   
    render() {
        const{note,notes, conversations,conversation, dispatch, loggedUser, onConversation}=this.props
        const handleRead =()=>{
            Axios.post(
                `api/conversation/seen`,
                {
                    noteId: note.id ,
                    projectId: note.projectId,
                }       
            ).then(result => {
                if (result.data) {
                    const returnId = result.data.map(m => m.linkId)
                    const { List } = notes
                    const count = conversation.ConversationCount
                    //set zero count of conversation
                    if(onConversation) {
                        _.find(List, { id: note.id }).unread = 0
                        dispatch({ type: "SET_NOTES_LIST", list: List });
                        // if (notes.Type === 'unread') {
                        //     const unreadList = List.filter(l => l.id !== note.id)
                        //     dispatch({ type: "SET_NOTES_LIST", list: unreadList });
                        // } else {
                        //     dispatch({ type: "SET_NOTES_LIST", list: List });
                        // }
                    } 
                
                    //find and add user from seencomments
                    const selectedMessage = conversations.selectedMessages.map(s => {
                        if (returnId.indexOf(s.id)>-1) {
                            s.isSeen = true
                            s.seenComments.push({ ...s.seenComments[0], userId: loggedUser.data.id,
                            user:{id:loggedUser.data.id,firstName:loggedUser.data.firstName, lastName:loggedUser.data.lastName, avatar:loggedUser.data.avatar} })
                        }
                        return s
                    })
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selectedMessage });
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: {...note, unread:0}});
                    dispatch({ type: "SET_CONVERSATION_COUNT", count: count - 1 })
                    
                    showToast("success", "Conversation marked as read!");
                }
            })
        }
        const handleUnread =()=>{
            const conv = _.sortBy(conversations.selectedMessages,'dateAdded').reverse()
            const latestMessage = conv[0]
            Axios.post(
                `api/conversation/unSeen`,
                {
                    noteId: note.id ,
                    projectId: note.projectId,
                    conversationIds: [latestMessage.id]
                }       
            ).then(result=>{
                if(result.data) {
                    const {List, Unread} = notes
                    const count = conversation.ConversationCount
                    //find and remove user from seencomments
                    const selectedMessage = conversations.selectedMessages.map(s => {
                        if (result.data.id.indexOf(s.id)>-1) {
                            s.seenComments =  s.seenComments.filter(s=>s.userId !== loggedUser.data.id)
                            s.isSeen = false
                        }
                        return s
                    })
                    if(onConversation) {  
                        _.find(List, { id: note.id }).unread = note.unread + 1
                        dispatch({ type: "SET_NOTES_LIST", list: List });   
                        // if(notes.Type === 'unread') {
                        //     Unread.unread=1
                        //     dispatch({ type: "SET_NOTES_LIST", list: [...[Unread],...List]});
                        // } else {
                        //     _.find(List, { id: note.id }).unread = note.unread + 1
                        //     dispatch({ type: "SET_NOTES_LIST", list: List });
                        // } 
                    
                    } 
                    const hasNew = conversations.selectedEvents.filter(f => f.event === "New Message")
                    if(hasNew.length === 0){
                        let newEvent = {
                            dateAdded: latestMessage.dateAdded,
                            dateUpdated: latestMessage.dateAdded,
                            event: "New Message",
                            isDeleted: 0,
                            notesId: note.id,
                            projectId: note.projectId
                        }
                        const events = [...conversations.selectedEvents, newEvent]
                        dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: events });
                        setTimeout(()=>{
                            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: conversations.selectedEvents.filter(f=>f.id)});
                        },60000)
                     
                    }
                    dispatch({type:"SET_CONVERSATION_COUNT", count:count + 1})
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selectedMessage});
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: {...note, unread:1}});
                    setTimeout(() => {
                        const ht = $('#divElement').prop('scrollHeight')
                        $('#divElement').animate({
                            scrollTop: ht+500
                        }, 2000);      
                       
                    }, 100);
                    showToast("success", "Conversation marked as unread!");
                  
                }
            })
        }
        return (
            <div>
                {note.unread > 0 ? 
                <a class={`readIconContainer`}   data-tooltip-id={`read-conversation`} onClick={handleRead}>
                    <i class="material-icons">email</i>
                </a> :
                    <a class={`readIconContainer`}   data-tooltip-id={`read-conversation`}  onClick={handleUnread}>
                        <i class="readIcon">{Icons.MarkAsRead}</i>
                       
                    </a>}
               
                <Tooltip id={`read-conversation`} place="bottom" effect="solid">{note.unread > 0?'Mark as Read':'Mark as Unread'}</Tooltip>
            </div>
        );
    }
}

export default Read;